export default __webpack_public_path__ + "assets/cdfee2a5396f3150f03da739873733e3.png";